import type { PersistedPreferenceCodec } from '../../utils/use-persisted-preference';
import { usePersistedPreference } from '../../utils/use-persisted-preference';

export const CLIENT_PORTAL_SIDEBAR_COLLAPSE_STORAGE_KEY = 'client-portal-sidebar-open';

const SIDEBAR_OPEN_CODEC: PersistedPreferenceCodec<boolean> = {
  parse: (raw) => raw !== 'false',
  serialize: (value) => String(value),
};

export function useClientPortalSidebarCollapse() {
  const [open, updateOpen] = usePersistedPreference(
    CLIENT_PORTAL_SIDEBAR_COLLAPSE_STORAGE_KEY,
    SIDEBAR_OPEN_CODEC,
    true,
  );

  return { open, setOpen: (next: boolean) => updateOpen(() => next) };
}
